import ProgressBarWithLabel from "components/Common/CircularProgressWithLabel/ProgressBarWithLabel";
import { CubesAvailableText } from "constants/text";
import { models } from "types/api/viewModels";
import { calculateCubePercentage, calculateRemainingCubes } from "utils/trucks";
import { TruckCubeCountTrackerContainer } from "./TruckCubeCountTracker.styles";

interface TruckCabCubeCountProps {
	truck?: models["TruckViewModel"] | null;
}

const TruckCubeCountTracker = ({ truck }: TruckCabCubeCountProps) => {
	const cubePercentage = calculateCubePercentage(truck?.cubeCount ?? 0, truck?.cubeCapacity ?? 0);

	return (
		<TruckCubeCountTrackerContainer>
			<span data-testid="cubes-available-data">
				{calculateRemainingCubes(truck?.cubeCount ?? 0, truck?.cubeCapacity ?? 0)} {CubesAvailableText}
			</span>
			<ProgressBarWithLabel
				data-testid="cubes-available-percentage"
				value={cubePercentage}
			/>
		</TruckCubeCountTrackerContainer>
	);
};

export default TruckCubeCountTracker;
